import { render } from "./DiarioEmocionalPrivacyPolicy.vue?vue&type=template&id=055effe1"
import script from "./DiarioEmocionalPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./DiarioEmocionalPrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__